import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireSelectionProjet.module.scss';

const FormulaireSelectionProjet = ({
  preconfigurerProjetId,
  gererProjetId,
  affichageProfil,
}) => {
  // Replace mapStateToProps with useSelector
  const listeProjets = useSelector((state) => state.authentifie.projects_list);
  const premier_valeur_filtre_projet = useSelector(
    (state) => state.authentifie.filtre_projects_list_id[0]
  );

  // State management with useState
  const [projetId, setProjetId] = useState(null);

  // Dernier gestionnaire reçu, lu par l'effet ci-dessous sans en être une
  // dépendance. Les formulaires composants fonction recréent gererProjetId à
  // chaque rendu : dans les dépendances, il relançait l'effet, qui l'appelait,
  // ce qui provoquait un rendu du parent et un nouveau gestionnaire. Sans
  // filtre de projet, premier_valeur_filtre_projet vaut undefined, projetId le
  // reste, et la boucle ne s'arrêtait jamais : aucune saisie ne tenait dans
  // les formulaires concernés (création de capteur, gabarit d'alarme…).
  const gererProjetIdRef = useRef(gererProjetId);
  gererProjetIdRef.current = gererProjetId;

  useEffect(() => {
    if (preconfigurerProjetId !== undefined && preconfigurerProjetId !== null) {
      setProjetId(preconfigurerProjetId);
    } else if (projetId === undefined || projetId === null) {
      setProjetId(premier_valeur_filtre_projet);
      gererProjetIdRef.current(premier_valeur_filtre_projet);
    }
    // projetId est volontairement absent : l'effet ne doit réagir qu'à la
    // pré-configuration et au filtre, pas à la sélection qu'il vient de faire.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preconfigurerProjetId, premier_valeur_filtre_projet]);

  // Event handlers
  const handleProjetIdChange = (event) => {
    const value = event.target.value;
    if (value === '-1' || value === -1) {
      setProjetId(null);
    } else {
      setProjetId(value);
    }
    gererProjetId(value);
  };

  return (
    <>
      <label className={styles.label} htmlFor="inlineFormCustomSelect">
        {checkMot('projet')}
      </label>
      <select
        className={[s.custom_select, styles.text_geral, s.card_body].join(' ')}
        onChange={handleProjetIdChange}
        disabled={affichageProfil === true}
        value={projetId || ''}
      >
        <option value="" disabled>
          Sélectionner un projet
        </option>
        {Object.entries(listeProjets).map(([_, project]) => (
          <option key={project.project_id} value={project.project_id}>
            {`id: ${project.project_id}, name: ${project.project_name}`}
          </option>
        ))}
      </select>
    </>
  );
};

export default FormulaireSelectionProjet;
